









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import SelectOption from "@/interfaces/SelectOption";
import GranularityHelper from "@/services/GranularityHelper";

const GRANULARITY_LABEL = [
  { id: "day", text: "Giorno" },
  { id: "sweek", text: "Settimana" },
  { id: "month", text: "Mese" },
];

@Component({
  components: {
    VMultiSwitcher,
  },
})
export default class GranularitySwitcher extends Vue {
  @Prop({ required: true }) readonly value!: GranularityHelper;

  protected granularity = this.value.value;

  get granularityItems(): SelectOption[] {
    return GRANULARITY_LABEL.map((label) => {
      return {
        ...label,
        disabled: this.value.validItems.indexOf(label.id) === -1,
      };
    });
  }

  @Watch("value.value")
  onGranularityValueChanged(value: "day" | "sweek" | "month") {
    this.granularity = value;
  }

  @Watch("granularity")
  onGranularityChanged(value: string) {
    this.$emit("changed", value);
  }

  protected onGranularityChange(value: "day" | "sweek" | "month") {
    this.granularity = value;
  }
}
